import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import useMoney from '../../../../../../../hooks/useMoney';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { BusinessPolicyItemViolationView } from '../businessPolicyViolation.types';
import { formatCriterionValue, getCriterionLabel } from '../businessPolicyViolation.utils';
import BusinessPolicyViolationDetailsLink from './BusinessPolicyViolationDetailsLink';
import BusinessPolicyViolationTitle from './BusinessPolicyViolationTitle';

interface BusinessPolicyItemViolationsProps {
  itemViolations: BusinessPolicyItemViolationView[];
  onOpenDetails?: () => void;
}

const BusinessPolicyItemViolations = ({
  itemViolations,
  onOpenDetails,
}: BusinessPolicyItemViolationsProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  return (
    <Stack sx={{ gap: 1 }}>
      {itemViolations.map(({ businessPolicy, messageCode, itemKey, criterion }) => (
        <Stack key={`${businessPolicy.id}-${itemKey}`} sx={{ gap: 0.25 }}>
          <Typography
            variant="body2"
            color="inherit"
            noWrap
            title={translate(messageCode, { expected: businessPolicy.name })}
          >
            •{' '}
            <BusinessPolicyViolationTitle
              messageCode={messageCode}
              policyName={businessPolicy.name}
            />
          </Typography>

          {criterion && (
            <Stack
              direction="row"
              sx={{ gap: 1.5, paddingLeft: 2, justifyContent: 'space-between' }}
            >
              <Typography variant="micro1" color="inherit">
                {getCriterionLabel(criterion)}
              </Typography>
              <Typography
                variant="micro1"
                color="inherit"
                sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}
              >
                {formatCriterionValue(criterion.reached, criterion.valueInput, formatMoney)} /{' '}
                {formatCriterionValue(criterion.expected, criterion.valueInput, formatMoney)}
              </Typography>
            </Stack>
          )}
        </Stack>
      ))}

      {onOpenDetails && <BusinessPolicyViolationDetailsLink onOpenDetails={onOpenDetails} />}
    </Stack>
  );
};

export default BusinessPolicyItemViolations;
